(() => {
  const root = document.querySelector('[data-aos-product-root]');
  if (!root) return;

  const mainImage = root.querySelector('.aos-pf__main-media img');
  const thumbs = Array.from(root.querySelectorAll('[data-aos-product-thumb]'));
  const variantSelect = root.querySelector('[data-aos-variant-select]');
  const price = root.querySelector('[data-aos-price]');
  const comparePrice = root.querySelector('[data-aos-compare-price]');
  const availability = root.querySelector('[data-aos-availability]');
  const addButton = root.querySelector('[data-aos-add-button]');
  const accelerated = root.querySelector('[data-aos-accelerated]');
  const stickyPrice = document.querySelector('[data-aos-sticky-price]');
  const stickyCta = document.querySelector('[data-aos-sticky-cta]');
  const productForm = root.querySelector('.aos-pf__form');

  const commerceContext = () => {
    const option = variantSelect?.options[variantSelect.selectedIndex];
    return {
      item_id: root.dataset.productId || root.dataset.productHandle,
      item_name: root.dataset.productTitle || '',
      item_variant: option?.dataset.variantTitle || '',
      variant_id: option?.value || root.dataset.variantId || '',
      price: Number(option?.dataset.priceMinor || root.dataset.priceMinor || 0) / 100,
      currency: root.dataset.currency || '',
      quantity: Number(productForm?.querySelector('[name="quantity"]')?.value || 1)
    };
  };

  const emitCommerce = (eventName, details = {}) => {
    const detail = { event: eventName, ecommerce: { items: [{ ...commerceContext(), ...details }] } };
    window.dispatchEvent(new CustomEvent('aos:commerce', { detail }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
  };

  const selectMedia = (thumb) => {
    if (!thumb || !mainImage) return;
    const source = thumb.dataset.imageSrc;
    if (!source) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = source;
    thumbs.forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    selectMedia(thumb);
    emitCommerce('select_content', { content_type: 'product_image', content_id: thumb.dataset.mediaId || '' });
  }));

  const updateVariant = () => {
    if (!variantSelect) return;
    const option = variantSelect.options[variantSelect.selectedIndex];
    if (!option) return;
    const available = option.dataset.available === 'true';
    if (price) price.textContent = option.dataset.price || '';
    if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = !option.dataset.comparePrice;
    }
    if (availability) {
      availability.textContent = available ? 'Available' : 'Currently unavailable';
      availability.classList.toggle('is-unavailable', !available);
    }
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'Add to cart' : 'Currently unavailable';
    }
    if (accelerated) accelerated.hidden = !available;
    if (stickyCta) {
      stickyCta.textContent = available ? 'Choose & buy' : 'Unavailable';
      stickyCta.setAttribute('aria-disabled', available ? 'false' : 'true');
    }
    if (option.dataset.mediaId) {
      selectMedia(thumbs.find((thumb) => thumb.dataset.mediaId === option.dataset.mediaId));
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
    root.dataset.variantId = option.value;
    root.dataset.priceMinor = option.dataset.priceMinor || root.dataset.priceMinor;
    emitCommerce('select_item');
  };

  if (variantSelect) variantSelect.addEventListener('change', updateVariant);
  if (productForm) productForm.addEventListener('submit', () => emitCommerce('add_to_cart'));
  if (stickyCta) stickyCta.addEventListener('click', () => emitCommerce('sticky_cta_click'));
  document.querySelectorAll('[data-aos-policy-link]').forEach((link) => link.addEventListener('click', () => emitCommerce('policy_link_click', { policy: link.dataset.aosPolicyLink })));
  document.querySelectorAll('.knowledge-card').forEach((card) => card.addEventListener('toggle', () => {
    if (card.open) emitCommerce('faq_open', { question: card.querySelector('summary')?.textContent?.trim() || '' });
  }));
  document.querySelectorAll('[data-aos-related-product]').forEach((link) => link.addEventListener('click', () => emitCommerce('select_item', { related_item: link.dataset.aosRelatedProduct })));
  emitCommerce('view_item');
})();
